/** Your GIF of the year: the one you sent most, playing, with how many times you sent it. */

import type { BlobSpec } from "../../story/stage";
import type { GifCard } from "../../types";
import { GifSpotlight } from "../GifSpotlight";
import { count } from "../shared";

const BLOBS: BlobSpec[] = [
  { colour: "fuchsia", x: 990, y: 280, r: 170, seed: 32.1, wob: 0.22 },
  { colour: "yellow", x: 70, y: 1790, r: 270, seed: 33.4, wob: 0.18 },
];

export function YourGif({ gif }: { gif: GifCard }) {
  return (
    <GifSpotlight
      gif={gif}
      blobs={BLOBS}
      kicker="Your GIF of the year"
      lead="The one you couldn't stop sending"
      line={
        <>
          You sent it <b>{count(gif.count)}</b> times this year.
        </>
      }
    />
  );
}
